/** 차량 이야기 영역별 앱 다운로드 OneLink */
export const CAR_STORY_APP_DOWNLOAD_LINKS = {
  /** 콘텐츠 상세 상단 (외부 브라우저 탑 네비 - "앱 다운로드" 버튼) */
  CONTENT_DETAIL_TOP: 'https://branded-content-tab.onelink.me/mjVj/fkvu61le',
  /** 콘텐츠 상세 하단 (외부 브라우저 - "마이클 앱 다운로드" 섹션) */
  CONTENT_DETAIL_BOTTOM: 'https://branded-content-tab.onelink.me/mjVj/5tz3f8rx',
  /** PC 차량 이야기 탑 네비 - "앱 다운로드" 버튼 */
  CAR_STORY_TOP_NAVIGATION:
    'https://branded-content-tab.onelink.me/mjVj/agvn6324',
} as const
